import { render, staticRenderFns } from "./IngresoPresupuestarioPage.vue?vue&type=template&id=6865c55d"
import script from "./IngresoPresupuestarioPage.js?vue&type=script&lang=js&external"
export * from "./IngresoPresupuestarioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports